export default function Email() {
  return (
    <svg
      className="fill-none hover:scale-105 transition-transform duration-200 ease-in-out"
      viewBox="2 4 20 15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="stroke-current stroke-2 stroke-round stroke-join-round"
        d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z"
      />
    </svg>
  );
};